
<div class="cp-content">
  <div class="close" @click="handleClose"></div>
  <div class="content">
    <div class="content-header"></div>
    <div class="content-center">
      <div class="title"></div>
      <div class="text">
        1，每个游戏的礼包内容均不同，请在秒杀成功物品时，提供对应游戏的信息，礼包将在游戏内直接发给您提供的游戏角色
        <br>
        2，礼包内容划分如下：
        <div v-for="(item, index) in prizeList" :key="index">
          <div class="name">{{item.title}}</div>
          <div class="prize">{{item.content}}</div>
        </div>
      </div>
    </div>
    <div class="content-footer"></div>
  </div>
</div>
